import { render, staticRenderFns } from "./RenameCohortIconDialog.vue?vue&type=template&id=6c5fb62d&scoped=true"
import script from "./RenameCohortIconDialog.vue?vue&type=script&lang=js"
export * from "./RenameCohortIconDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5fb62d",
  null
  
)

export default component.exports